/**
 * Le site n'a plus qu'un seul theme.
 *
 * Il en proposait quatre : clair, sombre, bleu, gris-bleu. La refonte est
 * construite en dur sur du sombre — texte blanc, verre translucide, pastilles
 * claires sur nuit — donc sur les deux jeux clairs la moitie des pages
 * devenait du blanc sur blanc. Plutot que de maquiller huit composants pour un
 * selecteur que personne n'utilise sur un portfolio, le choix est retire.
 *
 * Les valeurs vivent desormais sur :root dans index.css : la page est sombre
 * des le premier octet, sans attendre le script, donc plus de flash clair au
 * chargement. Les trois autres jeux sont conserves dans
 * src/archive/themes.css, hors du build.
 *
 * Ce composant reste pour une seule raison : faire le menage derriere
 * l'ancien systeme. Un visiteur qui avait choisi « clair » garde une classe
 * posee sur <html> et une valeur dans son navigateur ; sans ce nettoyage il
 * traine une classe morte a chaque visite.
 */

import { useEffect } from "react";

const CLE_ANCIENNE = "vite-ui-theme";
const CLASSES_ANCIENNES = ["light", "dark", "blue", "gray-blue"];

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    document.documentElement.classList.remove(...CLASSES_ANCIENNES);
    try {
      localStorage.removeItem(CLE_ANCIENNE);
    } catch {
      // Navigation privee, ou stockage refuse : rien a nettoyer, on continue.
    }
  }, []);

  return <>{children}</>;
}
